/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

/**
 * Pharmacy address structure
 */
export interface PharmacyAddressModel {
  /** Street address lines */
  line?: string[];
  /** City */
  city?: string | null;
  /** State */
  state?: string | null;
  /** Postal or ZIP code */
  postal_code?: string | null;
}
